import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class UploadService {
  constructor(private http: HttpClient) {}

  uploadFile(file: File): Observable<string> {
    const formData = new FormData();
    formData.append('file', file, file.name.replaceAll(' ', ''));

    return this.http.post(`~FileUploading`, formData, {
      responseType: 'text',
    });
  }
}
